import Store from 'store';

import {IRE_CLICK_ID} from 'constants/analytics/storages';
import {URL_PARAMETER} from 'constants/analytics/impactRadius';

import {getUrlParameter} from 'libs/url';
import {call} from 'redux-saga/effects';

/**
 * Save generated click ID to local storage.
 *
 * @param {string} id - Generated click ID.
 */
export const saveClickIdToStore = (id: string) => {
    Store.set(IRE_CLICK_ID, id);
};

/**
 * Generate click ID.
 */
export function* generateClickId() {
    try {
        const ireClickId = yield call([Store, 'get'], IRE_CLICK_ID);
        if (ireClickId) return;
        if (window.ire) yield call(window.ire, 'generateClickId', saveClickIdToStore);
    } catch (error) {
        yield call([console, 'log'], error);
    }
}

/**
 * Get click ID from URL.
 */
export function* getClickIdFromUrl() {
    const сlickIdFromUrl = yield call(getUrlParameter, URL_PARAMETER);
    if (сlickIdFromUrl) yield call(saveClickIdToStore, сlickIdFromUrl);
}

/**
 * Begin of saga.
 */
export default function* clickId() {
    yield call(getClickIdFromUrl);
}
